import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import Card from "ui/Card";
import SecondaryButton from "ui/buttons/SecondaryButton";

export default function ProductHistory() {
  const navigate = useNavigate();
  const { id } = useParams();

  return (
    <div className="flex flex-col space-y-3">
      <Card
        heading="Product History"
        description={`History for product #${id}`}
      >
        <div className="flex flex-col space-y-4">
          <p className="text-sm text-slate-700">
             No history data source is
            connected yet.
          </p>
          <div>
            <SecondaryButton
              title="Back to Products"
              onClick={() => navigate("/products/all")}
            />
          </div>
        </div>
      </Card>
    </div>
  );
}
